module.exports = __webpack_public_path__ + "img/clock7-01.c5cb5177.png";